var _ellipse, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6477,
    cy: 20,
    rx: 19.9861,
    ry: 20,
    fill: "#005CE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.54 12.9454C15.5397 13.4611 15.3348 13.9556 14.9702 14.3201C14.6056 14.6845 14.1113 14.8891 13.5959 14.8889C13.0806 14.8886 12.5865 14.6835 12.2222 14.3187C11.858 13.9539 11.6536 13.4592 11.6538 12.9435C11.6541 12.4278 11.859 11.9333 12.2236 11.5688C12.5882 11.2044 13.0825 10.9997 13.5979 11C14.1132 11.0003 14.6073 11.2054 14.9716 11.5702C15.3358 11.935 15.5403 12.4297 15.54 12.9454ZM15.5983 16.3288H11.7121V28.501H15.5983V16.3288ZM21.7385 16.3288H17.8717V28.501H21.6996V22.1135C21.6996 18.5551 26.3339 18.2246 26.3339 22.1135V28.501H30.1715V20.7913C30.1715 14.7926 23.3124 15.0163 21.6996 17.9621L21.7385 16.3288Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.dfc530fa6834c16d2ea4c1dc3dd30521.svg";
export { ForwardRef as ReactComponent };